import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate } from "react-router-dom";
import {
  checkMobile,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import FPVerifyOTPMobile from "./FPVerifyOTPMobile";
import ResetPasswordMobile from "./ResetPasswordMobile";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { handleKeyDown } from "../../../Common/FewCommonMethods";
import { useDispatch, useSelector } from "react-redux";
import { IS_LOGGED_IN_USER } from "../../../../assests/extention/commonfunction";
import { getProfile } from "../../../../redux/profile/action";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { mobilenumbervalidation } from "../../../Common/commonvalidation";

const path = "Assets/scss/FirstTimeUsers.module.scss";

const validationSchema = Yup.object().shape({
  country_code: Yup.string().required("Country code is required"),
  mobile_number: mobilenumbervalidation
});

const countryCodes = ["+91", "+971"];

const ForgetPasswordwithMobile = () => {
  const [lan, setLan] = useState(localStorage.getItem("laung") ?? "en");
  const navigate = useNavigate();
  const [nextPage, setnextPage] = useState(true);
  const [nextPage1, setnextPage1] = useState(true);
  const [valuess, setValuess] = useState(null);

  const profiledata = useSelector(({ profile: { profiledata } }) => profiledata,);
  const dispatch = useDispatch();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (IS_LOGGED_IN_USER) {
      dispatch(getProfile());
    }
  }, [IS_LOGGED_IN_USER]);

  const initialValues = {
    country_code: IS_LOGGED_IN_USER ? profiledata?.country_code : "+966",
    mobile_number: IS_LOGGED_IN_USER ? profiledata?.mobile_number : "",
  };

  const handleSubmit = (values) => {
    const state = values;

    checkMobile(values)
      .then((res) => {
        if (res.data.status) {
          sendOTP(values)
            .then((res) => {
              if (res.data.status) {
                urtoast(`OTP sent successfully.`, 1);
                setValuess(values);
                setnextPage(false);
              } else {
                urtoast(`${res?.data?.response?.message}`, 2);
              }
            })
            .catch((e) => {
              urtoast(`${e.message} || "Error sending OTP"`, 2);
            });
        } else {
          urtoast(`${res?.data?.response?.message}`, 2);
        }
      })
      .catch((e) => {
        urtoast(`${e.message} || "Error checking mobile number"`, 2);
      });
  };

  const modifyCountyCodeValue = (
    setFieldValue,
    countryCode,
    mobilewithcounty,
  ) => {
    const mobileNumber = mobilewithcounty.replace(countryCode, "");
    setFieldValue("mobile_number", mobileNumber);
    setFieldValue("country_code", `+${countryCode}`);
  };

  console.log(profiledata, 'profiledata');

  return (
    <>
      {nextPage && nextPage1 ? (
        <div className="mx-auto register">
          <img
            className="mail-img mb-2"
            src={`${CloudStorage.cloudurl}/Assets/Images/common/forgetpassword.svg`}
            alt=""
          />
          <h1 className="heading">Forgot password?</h1>
          <p style={{ display: "flex", justifyContent: "center" }}>
            Please enter your Mobile Number linked with your account.
          </p>
          <br></br>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnChange={false} // Optionally, you can set this to true to validate on change
            enableReinitialize={true}  // ✅ reinitialize when profiledata updates
          >
            {({ errors, values, touched, setFieldValue }) => (
              <Form>
                { }

                <div className="col-md-8 mx-auto form-sec mobile-otp">
                  <div className="form-group">
                    <label htmlFor="country_code">Country Code <AsteriskLabel /></label>
                    <PhoneInput
                      country={"sa"}
                      value={values.country_code}
                      onChange={(value, country) => {
                        modifyCountyCodeValue(
                          setFieldValue,
                          country.dialCode,
                          value,
                        );
                      }}
                      inputProps={{
                        name: "mobile_number",
                        id: "mobile_number",
                        className: "form-control",
                        readOnly: true,
                      }}
                      specialLabel=""
                      // inputclassName="d-none"
                      buttonStyle={{
                        borderRadius: "0",
                        border: "1px solid #ced4da",
                      }}
                      containerStyle={{ marginBottom: "10px" }}
                      disabled={IS_LOGGED_IN_USER}

                    />
                    <ErrorMessage
                      name="country_code"
                      component="div"
                      className="error"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="mobile_number">Mobile Number <AsteriskLabel /></label>
                    <Field
                      type="text"
                      name="mobile_number"
                      className={`form-control ${errors.mobile_number && touched.mobile_number ? "is-invalid" : ""}`}
                      placeholder="Enter mobile number"
                      onKeyDown={handleKeyDown}
                      disabled={IS_LOGGED_IN_USER}
                    />
                    <ErrorMessage
                      name="mobile_number"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="last-form">
                    <button type="submit" className="btn create-account">
                      Continue
                    </button>
                    <a
                      onClick={() => navigate(`/${lan}/forgetpassword/change`)}
                      className="login-password"
                    >
                      Use Email ID
                    </a>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : nextPage == false && nextPage1 == true ? (
        <FPVerifyOTPMobile
          setnextPage={setnextPage}
          setnextPage1={setnextPage1}
          valuess={valuess}
        />
      ) : (
        <ResetPasswordMobile valuess={valuess} />
      )}
    </>
  );
};

export default ForgetPasswordwithMobile;
